<template>
    <div>
        <transition-group
            enter-active-class="transition ease-out duration-500 delay-150 transform"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-out duration-100 transform"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <!-- <POIDocumentFormComponent v-show="currentStep == 1" :key="1" :step="1" />

            <POADocumentFormComponent v-show="currentStep == 2" :key="2" :step="2" />

            <POISelfieFormComponent v-show="currentStep == 3" :key="3" :step="3" /> -->

            <PersonalDetailsFormComponent v-show="currentStep == 1" :key="1" :step="1" />

            <EmploymentDetailsFormComponent v-show="currentStep == 2" :key="2" :step="2" />

            <InvestmentExperienceFormComponent v-show="currentStep == 3" :key="3" :step="3" />

            <InvestmentObjectivesFormComponent v-show="currentStep == 4" :key="4" :step="4" />

            <FinancialCircumstancesFormComponent v-show="currentStep == 5" :key="5" :step="5" />

            <BankingDetailsFormComponent v-show="currentStep == 6" :key="6" :step="6" />

            <LegalDocumentationFormComponent v-show="currentStep == 7" :key="7" :step="7" />

            <DeclarationsFormComponent v-show="currentStep == 8" :key="8" :step="8" />
        </transition-group>
    </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import PersonalDetailsFormComponent from "@components/forms/PersonalDetailsFormComponent";
import EmploymentDetailsFormComponent from "@components/forms/EmploymentDetailsFormComponent";
import InvestmentExperienceFormComponent from "@components/forms/InvestmentExperienceFormComponent";
import InvestmentObjectivesFormComponent from "@components/forms/InvestmentObjectivesFormComponent";
import FinancialCircumstancesFormComponent from "@components/forms/FinancialCircumstancesFormComponent";
import BankingDetailsFormComponent from "@components/forms/BankingDetailsFormComponent";
import LegalDocumentationFormComponent from "@components/forms/LegalDocumentationFormComponent";
import DeclarationsFormComponent from "@components/forms/DeclarationsFormComponent";
// import POIDocumentFormComponent from "@components/forms/POIDocumentFormComponent";
// import POISelfieFormComponent from "@components/forms/POISelfieFormComponent";
// import POADocumentFormComponent from "@components/forms/POADocumentFormComponent"

export default {
    name: "CreateAccountPage",
    props: {},
    components: {
        ValidationObserver,
        PersonalDetailsFormComponent,
        EmploymentDetailsFormComponent,
        InvestmentExperienceFormComponent,
        InvestmentObjectivesFormComponent,
        FinancialCircumstancesFormComponent,
        BankingDetailsFormComponent,
        LegalDocumentationFormComponent,
        DeclarationsFormComponent
    },
    computed: {
        currentStep(){
            return this.$route.params.step
        }
    },
    data: function () {
        return {

        };
    },
    methods: {
    },
};
</script>
